import { combineEpics } from 'redux-observable';
import { defer, of } from 'rxjs';
import { catchError, map, mergeMapTo } from 'rxjs/operators';
import { commonHandleShowErrorMessage } from 'src/actions/common';
import { IHelps, initialize, setHelps } from 'src/actions/help';
import 'whatwg-fetch';
import i18n from '../resources/i18n';
import { EpicType, ofAction, withIndicator } from './common';

/**
 * ヘルプ定義取得関数
 */
const fetchHelp: () => Promise<IHelps> = async () =>
	fetch(getpath()).then(response => response.json());
const getpath = (): string => {
	let urlLang: string = '';
	if (i18n.language === 'ja') {
		urlLang = `${process.env.PUBLIC_URL}/conf/help.json`;
	} else if (i18n.language === 'en') {
		urlLang = `${process.env.PUBLIC_URL}/conf/help_en.json`;
	}
	return urlLang;
};
/**
 * ヘルプコンポーネント初期化時にヘルプ一覧を取得してset
 * @param action$ ActionsObservable
 */
const fetchEpic: EpicType = action$ =>
	action$.pipe(
		ofAction(initialize),
		mergeMapTo(
			defer(fetchHelp).pipe(
				map(help => setHelps(help)),
				catchError((err, caught) => {
					console.error('マニュアル定義取得失敗', err, caught);
					return of(
						commonHandleShowErrorMessage({
							content: 'マニュアル定義の取得に失敗しました。',
							replacements: [],
						})
					);
				}),
				withIndicator('help')
			)
		)
	);

export const helpEpic = combineEpics(fetchEpic);



// WEBPACK FOOTER //
// ./src/epics/help.ts